import MARRUA_EXT_1 from "./MARRUA_EXT_1";
export default {
  MARRUA_EXT_1,
};
